import React, { useEffect, useState } from 'react';
import PropTypes from "prop-types";
import { Link } from 'react-router-dom';
import withRouter from 'Common/withRouter';
import navdata from "../LayoutMenuData";
import { withTranslation } from "react-i18next";
import { faCaretRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const HorizontalLayout = (props: any) => {
  const navData = navdata()?.props.children;
  const [menuItems, setMenuItems] = useState(navData);
  const [openMenus, setOpenMenus] = useState<{ [key: string]: boolean }>({});
  const [openSubMenus, setOpenSubMenus] = useState<{ [key: string]: boolean }>({});

  const toggleMenu = (id: string, e: React.MouseEvent) => {
    e.stopPropagation();

    setOpenMenus((prev) => {
      const isOpening = !prev[id]; // new state for this id
      const newState: { [key: string]: boolean } = {};

      // close all menus first
      Object.keys(prev).forEach((key) => {
        newState[key] = false;
        const el = document.getElementById(`submenu-${key}`);
        if (el) {
          el.style.maxHeight = "0px";
          el.style.opacity = "0";
        }
      });

      // then handle this submenu
      newState[id] = isOpening;

      setTimeout(() => {
        const el = document.getElementById(`submenu-${id}`);
        if (el) {
          if (isOpening) {
            el.style.maxHeight = `${el.scrollHeight}px`;
            el.style.opacity = "1";
          } else {
            el.style.maxHeight = "0px";
            el.style.opacity = "0";
          }
        }
      }, 50);

      return newState;
    });
  };

  const toggleSubMenu = (id: string, e: React.MouseEvent) => {
    e.stopPropagation();

    setOpenSubMenus((prev) => {
      const isOpening = !prev[id];
      const newState: { [key: string]: boolean } = {};

      Object.keys(prev).forEach((key) => {
        newState[key] = false;
        const el = document.getElementById(`subsubmenu-${key}`);
        if (el) {
          el.style.maxHeight = "0px";
          el.style.opacity = "0";
        }
      });

      newState[id] = isOpening;

      setTimeout(() => {
        const el = document.getElementById(`subsubmenu-${id}`);
        if (el) {
          if (isOpening) {
            el.style.maxHeight = `${el.scrollHeight}px`;
            el.style.opacity = "1";
          } else {
            el.style.maxHeight = "0px";
            el.style.opacity = "0";
          }
        }
      }, 50);

      return newState;
    });
  };

  useEffect(() => {
    window.dispatchEvent(new Event('resize'));
    const menuPosSetOnClicknHover = () => {
      const isElements = document.querySelectorAll("#navbar-nav > li.nav-item");
      Array.from(isElements).forEach(function (item) {
        item.addEventListener("click", menuItem, false);
        item.addEventListener("mouseover", menuItem, false);
      });
    };
    const menuItem = (e: any) => {
      const dropdownMenu = e.target;
      const subMenus = dropdownMenu.nextElementSibling || dropdownMenu.parentElement.nextElementSibling;
      if (dropdownMenu && subMenus) {
        const dropdownOffset = subMenus.getBoundingClientRect();
        const dropdownWidth = subMenus.offsetWidth;
        const dropdownHeight = subMenus.offsetHeight;
        const screenWidth = window.innerWidth;
        const screenHeight = window.innerHeight;
        const maxDropdownX = dropdownOffset.left + dropdownWidth + 100;
        const maxDropdownY = dropdownOffset.top + dropdownHeight + 100;
        const isDropdownOffScreen = maxDropdownX > screenWidth || maxDropdownY > screenHeight;
        if (isDropdownOffScreen) {
          if (subMenus.classList.contains("menu-dropdown")) {
            subMenus.classList.add("dropdown-custom-right");
          }
        }
      }
    };
    menuPosSetOnClicknHover();
    return () => {
      const isElements = document.querySelectorAll("#navbar-nav > li.nav-item");
      Array.from(isElements).forEach(function (item) {
        item.removeEventListener("click", menuItem, false);
        item.removeEventListener("mouseover", menuItem, false);
      });
    };
  }, []);

  useEffect(() => {
    setMenuItems(navData); // set once
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    const initMenu = () => {
      const pathName = process.env.PUBLIC_URL + props.router.location.pathname;
      const ul: any = document.getElementById("navbar-nav");
      if (!ul) return;
      const items = ul.getElementsByTagName("a");
      let itemsArray = [...items]; // converts NodeList to Array
      removeActivation(itemsArray);
      let matchingMenuItem = itemsArray.find((x) => {
        return x.pathname === pathName;
      });
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem);
      }
    };
    const timer = setTimeout(initMenu, 0);
    return () => clearTimeout(timer);
  }, [props.router.location.pathname, props.layoutType]);

  function activateParentDropdown(item: any) {
    item.classList.add("active");
    let parentCollapseDiv = item.closest(".collapse.menu-dropdown");
    if (parentCollapseDiv) {
      // to set aria expand true remaining
      parentCollapseDiv.classList.add("show");
      parentCollapseDiv.parentElement.children[0].classList.add("active");
      parentCollapseDiv.parentElement.children[0].setAttribute("aria-expanded", "true");
      if (parentCollapseDiv.parentElement.closest(".collapse.menu-dropdown")) {
        parentCollapseDiv.parentElement.closest(".collapse").classList.add("show");
        var parentElementDiv = parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling;
        if (parentElementDiv)
          if (parentElementDiv.closest(".collapse"))
            parentElementDiv.closest(".collapse").classList.add("show");
        parentElementDiv.classList.add("active");
        var parentElementSibling = parentElementDiv.parentElement.parentElement.parentElement.previousElementSibling;
        if (parentElementSibling) {
          parentElementSibling.classList.add("active");
        }
      }
      return false;
    }
    return false;
  }

  const removeActivation = (items: any) => {
    let actiItems = items.filter((x: any) => x.classList.contains("active"));
    actiItems.forEach((item: any) => {
      if (item.classList.contains("menu-link")) {
        if (!item.classList.contains("active")) {
          item.setAttribute("aria-expanded", false);
        }
        if (item.nextElementSibling) {
          item.nextElementSibling.classList.remove("show");
        }
      }
      if (item.classList.contains("nav-link")) {
        if (item.nextElementSibling) {
          item.nextElementSibling.classList.remove("show");
        }
        item.setAttribute("aria-expanded", false);
      }
      item.classList.remove("active");
    });
  };

  useEffect(() => {
    if (!menuItems || menuItems?.length === 0) return;
    const pathName = props?.router?.location?.pathname ?? "";

    let newOpenMenus: { [key: string]: boolean } = {};
    let newOpenSubMenus: { [key: string]: boolean } = {};

    menuItems?.forEach((item: any) => {
      if (item?.subItems) {
        item.subItems?.forEach((subItem: any) => {
          if (subItem?.link === pathName) {
            newOpenMenus[item?.id] = true;
          }
          if (subItem?.subItems) {
            subItem?.subItems?.forEach((child: any) => {
              if (child?.link === pathName) {
                newOpenMenus[item?.id] = true;
                newOpenSubMenus[subItem?.id] = true;
              }
            });
          }
        });
      }
    });

    setOpenMenus(newOpenMenus);
    setOpenSubMenus(newOpenSubMenus);
  }, [props?.router?.location?.pathname, menuItems]);

  return (
    <React.Fragment>
      <>
        <div className="sidebar-wrapper">
          <ul className="nav flex-column mt-1">
            {(menuItems || []).map((item: any, key: number) => (
              <li className="nav-item  " key={key} id={`menu-item-${item.id}`}>
                <div
                  className={`nav-link d-flex justify-content-between align-items-center ms-2 ${(["dashboard", "interstore"].includes(item.id) && props.router.location.pathname === item.link)
                    ? "active"
                    : ""
                    }`}
                  style={
                    (["dashboard", "interstore"].includes(item.id) &&
                      props.router.location.pathname === item.link)
                      ? { borderRadius: "4px" }
                      : {}
                  }
                  onClick={(e) => Array.isArray(item.subItems) && item.subItems.length > 0 && toggleMenu(item.id, e)}
                >
                  {Array.isArray(item.subItems) && item.subItems.length > 0 ? (
                    <button
                      type="button"
                      onClick={(e) => toggleMenu(item.id, e)}
                      className="bg-transparent border-0 text-start text-reset p-0 d-flex align-items-center flex-grow-1"
                      style={{ boxShadow: "none" }}
                    >
                      {item.icon && <i className={`${item.icon} me-2`}></i>}
                      <span className="fw-bold">{item.label}</span>
                    </button>
                  ) : (
                    <Link
                      to={item.link || "#"}
                      className={`nav-link d-flex align-items-center text-reset flex-grow-1  ${item.id === "dashboard" && props.router.location.pathname === item.link ? "active" : ""
                        }`}
                      style={{ padding: "0px", }}
                    >
                      {item.icon && <i className={`${item.icon} me-2`}></i>}
                      <span className="fw-bold">{item.label}</span>
                    </Link>
                  )}
                  {Array.isArray(item.subItems) && item.subItems.length > 0 && (
                    <span
                      role="button"
                      onClick={(e) => toggleMenu(item.id, e)}
                      className="ms-2"
                    >
                      <FontAwesomeIcon
                        icon={faCaretRight}
                        className={`transition-icon ${openMenus[item.id] ? "rotate-icon" : ""}`}
                      />
                    </span>
                  )}
                </div>
                {Array.isArray(item.subItems) && item.subItems.length > 0 && (
                  <div className={`submenu-collapse ${openMenus[item.id] ? "open" : ""}`}>
                    <ul className="nav nav-sm flex-column" style={{ paddingLeft: "1rem" }}>
                      {item.subItems.map((subItem: any, subKey: number) => (
                        <li className="nav-item" key={subKey}>
                          {Array.isArray(subItem.subItems) && subItem.subItems.length > 0 ? (
                            <>
                              <div
                                className="nav-link d-flex justify-content-between align-items-center"
                                onClick={(e) => toggleSubMenu(subItem.id, e)}
                                style={{ cursor: "pointer" }}
                              >
                                <span className="inline-block">
                                  {subItem.icon && <i className={`${subItem.icon} me-2`}></i>}
                                  {subItem.label}
                                </span>
                                <FontAwesomeIcon
                                  icon={faCaretRight}
                                  className={`transition-icon ${openSubMenus[subItem.id] ? "rotate-icon" : ""
                                    }`}
                                />
                              </div>
                              <div
                                id={`subsubmenu-${subItem.id}`}
                                className={`submenu-collapse ${openSubMenus[subItem.id] ? "open" : ""
                                  }`}
                              >
                                <ul className="nav nav-sm flex-column">
                                  {Array.isArray(subItem.subItems) &&
                                    subItem.subItems.map((child: any, childKey: number) => (
                                      <li className="nav-item" key={childKey}>
                                        <Link
                                          to={child.link}
                                          className={`nav-link ${props?.router?.location?.pathname === child?.link ? "active" : ""}`}
                                          onClick={() => {
                                            if (window.innerWidth <= 768) {
                                              window.dispatchEvent(new Event("closeSidebarOnMobile"));
                                            }
                                          }}
                                        >
                                          {child.label}
                                        </Link>
                                      </li>
                                    ))}
                                </ul>
                              </div>
                            </>
                          ) : (
                            <Link
                              to={subItem.link || "/#"}
                              className="nav-link"
                              onClick={() => {
                                if (window.innerWidth <= 768) {
                                  window.dispatchEvent(new Event("closeSidebarOnMobile"));
                                }
                              }}
                            >
                              {subItem.label}
                            </Link>
                          )}
                        </li>
                      ))}

                    </ul>
                  </div>
                )}
              </li>
            ))}
          </ul>
        </div>
      </>
    </React.Fragment >
  );
};

HorizontalLayout.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(HorizontalLayout));
